var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "mq9-flight.8cfbc7c2.png","uri@2x": __webpack_public_path__ + "mq9-flight.a358d4df.png","uri@3x": __webpack_public_path__ + "mq9-flight.2fb69277.png",
    width: 132,
    height: 335
});